module.exports = __webpack_public_path__ + "img/Passport_Sm.c65f401b.svg";